import { Component } from '@angular/core';

@Component({
    selector: 'fp-farewell',
    templateUrl: './farewell.component.html',
    styleUrls: ['./farewell.component.scss'],
    standalone: false
})
export class FarewellComponent {
  constructor() {}
}
